<template>
	<ProcessCreatePage>
		<Header :title="$t('new_damage_case_overview_image').toString()">
			<p v-if="isAppContainer">
				{{ $t('take_image_of_vehicle') }}<br />
				{{ $t('tablet_horizontal') }}
			</p>
			<p v-else>
				{{ $t('upload_image_of_vehicle') }}
			</p>
		</Header>

		<div class="main">
			<BaseCamera
				orientation="landscape"
				@snapshot="overviewImage = $event"
				:label="$t('add_overview_image')"
				:take-image-label="$t('activate_camera')"
				:remove-upload-button="isAppContainer"
				:take-image="true"
				:allow-upload-in-app-container="false"
			/>
		</div>

		<Footer
			@backButtonClick="goBack"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="!overviewImage"
			:is-back-button="!isBackButton"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import BaseCamera from '../../forms/inputs/BaseCamera';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'OverviewImage',
	components: { ProcessCreatePage, BaseCamera, Footer, Header },
	mixins: [AppContainerMixin],
	data() {
		return {
			overviewImage: null,
			vehicleKilometrage: '',
		};
	},
	props: {
		isBackButton: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next', null);
			} else if (this.validate()) {
				this.$swal({
					title: this.$t('store_mileage').toString(),
					text: this.$t('update_vehicles_mileage').toString(),
					icon: 'question',
					input: 'number',
					inputValue: this.vehicleKilometrage,
					confirmButtonText: this.$t('update').toString(),
					cancelButtonText: this.$t('general.no').toString(),
					inputPlaceholder: '1244',
					validationMessage: this.$t('enter_valid_number').toString(),
					inputAttributes: {
						minNumber: 1,
						maxLength: 6,
					},
					inputValidator: inputValue => {
						if (isNaN(inputValue)) {
							return this.$t('enter_valid_number');
						} else if (!inputValue) {
							return this.$t('enter_number');
						}
					},
					showCancelButton: true,
				}).then(result => {
					if (result.value && result.isConfirmed) {
						this.vehicleKilometrage = result.value;
					}
					this.$emit('next', this.$data);
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('upload_or_skip').toString(), 'warning');
			}
		},
		validate: function() {
			return !!this.overviewImage;
		},
	},
};
</script>

<style scoped></style>
